import "./bootstrap";

import Glide from "@glidejs/glide";

import { Livewire } from "../../vendor/livewire/livewire/dist/livewire.esm";

import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

import SignaturePad from "signature_pad";

import "livewire-sortable";

import { Html5Qrcode } from "html5-qrcode";

import { Boarding } from "boarding.js";
import "boarding.js/styles/main.css";
import "boarding.js/styles/themes/basic.css";

import * as pdfjsLib from "pdfjs-dist";

window.FilePond = FilePond;
window.FilePondPluginImagePreview = FilePondPluginImagePreview;
window.FilePondPluginFileValidateSize = FilePondPluginFileValidateSize;
window.FilePondPluginFileValidateType = FilePondPluginFileValidateType;

window.SignaturePad = SignaturePad;
window.Html5Qrcode = Html5Qrcode;
window.pdfjsLib = pdfjsLib;
window.Boarding = Boarding;
window.Glide = Glide;

Livewire.start();
